module.exports = __webpack_public_path__ + "img/tips (1).6c637860.png";